import { updateField } from 'vuex-map-fields'

export default {
  SET_STORES (state, payload) {
    state.stores = payload.map(record => { return { ...record, ...{ selected: true, active: false } } })
  },
  updateField
}
